import DummyText from "./utils/DummyText";
import Navigation from "./components/Navigation";
("");
// import * as bootstrap from "bootstrap";
// import "bootstrap/dist/js/bootstrap.bundle.js";

export default class Common {
  constructor() {}

  init() {
    this.initDummyText();
    this.initNavigation();
    this.removeGradientWhenOpenModal();
    this.hideModalWhenClickMenuItem();
    this.hidecustomcursor();
  }

  initDummyText() {
    let dummyText = document.querySelectorAll("[js-dummytext]");
    for (let dt of dummyText) {
      new DummyText(dt);
    }
  }

  initNavigation() {
    let navDOM = document.querySelector("nav");
    let partNav = new Navigation(navDOM);
    partNav.setHideOnScroll();
    partNav.handleMenuControl();
  }

  removeGradientWhenOpenModal() {
    let modalEls = document.querySelectorAll(".modal");
    const navGradient = document.querySelector("[js-navbg]");
    for (let [i, modalEl] of modalEls.entries()) {
      modalEl.addEventListener("show.bs.modal", (e) => {
        navGradient.classList.add("hide-gradient");
      });
      modalEl.addEventListener("hide.bs.modal", (e) => {
        navGradient.classList.remove("hide-gradient");
      });
    }
  }

  hideModalWhenClickMenuItem() {
    let menuItem = document.querySelectorAll("[js-menu-item]");
    let closeBtn = document.querySelectorAll("[data-bs-dismiss]");
    for (let [i, item] of menuItem.entries()) {
      item.addEventListener("click", () => {
        // console.log("here");
        // console.log(closeBtn);
        for (let [i, btn] of closeBtn.entries()) {
          btn.click();
        }
      });
    }
  }

  hidecustomcursor() {
    document.documentElement.style.cursor = "none";
  }
}
